/*
  Homepage hero film (sections/home-hero.liquid). The poster frame is already on screen; this loads the muted loop
  once the page is idle, the phone crop below 768px, plays it only while it is on screen and the tab is visible, and
  gives it a pause button. Reduced motion: the film never starts.
*/
const hero = document.querySelector('[data-hero]');
const video = hero?.querySelector('[data-hero-video]');
const toggle = hero?.querySelector('[data-hero-toggle]');
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const saveData = navigator.connection?.saveData;

if (video && !reduce && !saveData) {
  let userPaused = false;
  let visible = true;

  const setToggle = (playing) => {
    if (!toggle) return;
    toggle.hidden = false;
    toggle.querySelector('[data-hero-toggle-icon="pause"]').hidden = !playing;
    toggle.querySelector('[data-hero-toggle-icon="play"]').hidden = playing;
    toggle.querySelector('[data-hero-toggle-label]').textContent = playing ? 'Pause film' : 'Play film';
  };

  const play = () => {
    if (userPaused || !visible || document.hidden) return;
    video.play().then(() => setToggle(true)).catch(() => {});
  };

  const load = () => {
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    video.src = mobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
    video.addEventListener('playing', () => video.setAttribute('data-playing', ''), { once: true });
    play();
  };

  const start = () => ('requestIdleCallback' in window ? requestIdleCallback(load, { timeout: 2500 }) : setTimeout(load, 1200));
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });

  new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    if (visible) play();
    else video.pause();
  }).observe(hero);

  document.addEventListener('visibilitychange', () => (document.hidden ? video.pause() : play()));

  toggle?.addEventListener('click', () => {
    if (video.paused) {
      userPaused = false;
      play();
    } else {
      userPaused = true;
      video.pause();
      setToggle(false);
    }
  });
}
